import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import authentication from 'react-azure-b2c';

const { REACT_APP_BASE_URL } = process.env;

const api = () => {
  const defaultOptions = {
    baseURL: REACT_APP_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      // Asks the API for error codes ({ Code, Message }) used to translate errors (see getBackendErrorMessage)
      'X-Error-Codes': '1',
    }
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use((config: AxiosRequestConfig) => {
    const token = authentication.getAccessToken().accessToken;
    
    if(!!config.headers) {
      config.headers.Authorization =  token ? `Bearer ${token}` : '';
      config.headers['Access-Control-Max-Age'] = 0;
    }
    
    return config;
  });

  // return response
  instance.interceptors.response.use((response: AxiosResponse) => response)

  return instance;
};

export default api();